import type { FC } from "react";
import type { TimelineItemResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { ResolvingNowItem } from "web_myplann/NotificationCenter/Components/ResolvingNowItem";
import { TimelineSection } from "web_myplann/NotificationCenter/Components/TimelineSection";

interface ResolvingNowSectionProps {
	items: TimelineItemResponseDTO[];
	onItemClick?: (item: TimelineItemResponseDTO) => void;
}

export const ResolvingNowSection: FC<ResolvingNowSectionProps> = ({
	items,
	onItemClick,
}) => {
	const { t } = useResource();

	if (items.length === 0) {
		return null;
	}

	return (
		<TimelineSection
			title={t(Resources.NotificationCenter.UpcomingGroups.ResolvingNow)}
			testId="resolving-now-section"
		>
			{items.map((item, index) => (
				<ResolvingNowItem
					key={item.id}
					item={item}
					onClick={onItemClick}
					isLast={index === items.length - 1}
				/>
			))}
		</TimelineSection>
	);
};
